import shipficiencyLogoUrl from "../../assets/shipficiency-logo.png";

export const shipficiencyLogo = shipficiencyLogoUrl;
